import { Link, usePage } from '@inertiajs/react'

import { Container, Title, Text, Anchor, Group, Stack } from '@mantine/core'
import StationLists from '../_StationLists'
import Seo from '../../_Seo'
import { breadcrumbList } from '../../_structuredData'
import { useI18n } from '../../_i18n'
import { useLocalePath } from '../../_localePath'

export default function StatePage({ state }) {
  const { t } = useI18n()
  const localePath = useLocalePath()
  const s = state || {}
  const country = s.country || {}
  const tide = s.tide_stations || []
  const current = s.current_stations || []
  const { site_url: siteUrl = '' } = usePage().props

  return (
    <>
      <Seo
        title={t('location_title', { name: s.name })}
        description={t('state_seo_description', { name: s.name, country: country.name })}
        jsonLd={breadcrumbList(siteUrl, [
          { name: country.name, path: localePath(`/countries/${country.permalink}`) },
          { name: s.name, path: localePath(`/states/${s.permalink}`) },
        ])}
      />
      <Container size="md" py="xl">
        {country.permalink && (
          <Group gap="xs" mb="xs">
            <Anchor
              component={Link}
              href={localePath(`/countries/${country.permalink}`)}
              c="dimmed"
              size="sm"
            >
              {country.name}
            </Anchor>
          </Group>
        )}
        <Title order={1} mb="lg">
          {s.name}
        </Title>
        <Stack gap="md">
          <StationLists tideStations={tide} currentStations={current} />
          {!tide.length && !current.length && (
            <Text c="dimmed">{t('no_stations_found_location')}</Text>
          )}
        </Stack>
      </Container>
    </>
  )
}
